import { Component, OnInit } from '@angular/core';

@Component({
  template: `
    <admin-menu></admin-menu>
  `
})
export class AdminComponent {

}